import React from 'react'

import { AppLayout, LanguageSelector } from '@/components'
import { useApp } from '@/hooks'
import { t } from '@/i18n'

import { useCanWrite } from '@/hooks'
import { SearchContextProvider } from './SearchContext'
import ActiveFilter from './components/ActiveFilters'
import HeaderMenu from './components/HeaderMenu'
import SearchBox from './components/SearchBox'
import SearchResult from './components/SearchResult'
const HomePage: React.FC = () => {
  const { me } = useApp()
  const canWrite = useCanWrite()

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
          {canWrite && <HeaderMenu />}
        </div>
      }
    >
      <SearchContextProvider>
        <div className="data-wrap centered">
          <div className="content-box">
            <div className="main-search">
              <h1>{t('what_do_you_need_to_search')}</h1>
              <form>
                <SearchBox />
                <ActiveFilter />
                <SearchResult />
              </form>
            </div>
          </div>
        </div>
      </SearchContextProvider>
    </AppLayout>
  )
}

export default HomePage
